<template>
  <div>
    <div class="parent">
      <div class="parent-side">
        <div>
          <app-row title="نام: " :value="personnel.Name" />
          <app-row title="نام خانوادگی: " :value="personnel.FamilyName" />
          <app-row
            v-if="personnel.Semat"
            title="سمت"
            :value="personnel.Semat"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["personnel"],
  components: {
    appRow: DetailRow,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showMajorDetail() {
      this.$emit("clicked", this.index);
    },
  },
  computed: {
    showSelectedDetails() {
      if (this.showDetails && this.selectedIndex === this.index) {
        return true;
      }
      return false;
    },
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
  created() {},
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  width: 100%;
  border-bottom: 1px solid;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
</style>
